module.exports = __webpack_public_path__ + "img/wibo_bed_3.ef14a0e6.png";